import React, { useEffect, useState } from "react";
import { StaticDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { Button, IconButton, Checkbox } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import BasicCustomTable from "../../../../component/basicTable";
import { blackoutColumn } from "../../../../constants/bussiness";
import axiosInstance from "../../../../configuration/request";
import { useSnackbar } from "../../../../component/SnackbarContext";
import { useSelector } from "react-redux";

export default function BlackoutDates() {
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [tempDates, setTempDates] = useState([]);
  const [finalDates, setFinalDates] = useState([]);
  const { loginDetails } = useSelector((state) => state.counter);
  const storeId = loginDetails.storeId || null;
  const showSnackbar = useSnackbar();


  useEffect(() => {
    fetchBlackout();
  }, []);

  const fetchBlackout = () => {
    axiosInstance
      .get(`/customer/store/backout-dates/${storeId}`)
      .then((res) => {
        const newRows = res?.data?.map((item) => ({
          date: item?.date?.split("T")[0],
          open_time: item?.open ? dayjs(item?.open , "hh:mm A") : null,
          close_time: item?.close ? dayjs(item?.close , "hh:mm A") : null,
          override: item?.status?.toLowerCase() === "active" ? true : false,
          order_status:
            item?.status?.toLowerCase() === "active" ? "open" : "closed",
        }));

        setFinalDates(newRows);
      })
      .catch((err) => showSnackbar("Something went wrong!", "error"));
  };

  const addToTemp = (date) => {
    const formatted = dayjs(date).format("YYYY-MM-DD");
    if (!tempDates.some((d) => d.date === formatted)) {
      setTempDates([
        ...tempDates,
        {
          date: formatted,
          open_time: "",
          close_time: "",
          override: false,
          order_status: "Closed",
        },
      ]);
    }
  };

  const removeTempDate = (date) => {
    setTempDates(tempDates.filter((d) => d.date !== date));
  };

  const addAllToTable = () => {
    const newRows = tempDates.map((date) => ({
      date: date.date,
      open: null,
      close: null,
      status: "inactive",
      note: "",
    }));
    setTempDates([]);
    createBlackoutDates(newRows);
  };

  const createBlackoutDates = (payload) => {
    axiosInstance
      .post(`/customer/store/backout-dates/add/${storeId}`, payload)
      .then(() => {
        fetchBlackout();
        showSnackbar("Dates updated sucessfully");
      })
      .catch((err) => {
        showSnackbar(err.response.data.message, "error");
      });
  };

  const handleTimeChange = (row, field, value) => {
    setFinalDates((prev) =>
      prev.map((item) =>
        item.date === row.date ? { ...item, [field]: value } : item
      )
    );
  };

const onAccept = (row, field, value) => {
  // Only check if both times are present
  if (row.open_time && row.close_time) {
    if (!dayjs(row.open_time).isBefore(dayjs(row.close_time))) {
      showSnackbar("Start time must be before end time.", "error");

      setFinalDates(prev =>
        prev.map(item =>
          item.date === row.date ? { ...item, [field]: null } : item
        )
      );
      return;
    }
  }
  if(dayjs(row.open_time) && dayjs(row.close_time) && row.order_status === "open"){
    updateBlackoutDate(row);
  }
  
};




  const onStatusChange = (newStatus, row) => {
    const capitalized = newStatus.charAt(0).toUpperCase() + newStatus.slice(1);
    setFinalDates((prev) =>
      prev.map((item) =>
        item.date === row.date ? { ...item, order_status: capitalized } : item
      )
    );

    if (capitalized === "Open") {
      if (!row.open_time || !row.close_time) {
        showSnackbar("Please set both start and end times before opening.", "warning");
        return;
      }

      if (row.open_time.isSameOrAfter(row.close_time)) {
        showSnackbar("Start time must be before end time.", "warning");
        return;
      }

       const updatedRow = {
        ...row,
        order_status:newStatus
      };
      updateBlackoutDate(updatedRow);
    } else if (capitalized === "Closed") {
       const updatedRow = {
         ...row,
         open_time:null,
         close_time:null,
         order_status:newStatus
       }
      updateBlackoutDate(updatedRow);
    }
  };

  const updateBlackoutDate = (dateData) => {
    let payload = {
      date: dateData?.date,
      open: dateData.open_time
        ? dayjs(dateData.open_time).format("hh:mm A")
        : null,
      close: dateData.close_time
        ? dayjs(dateData.close_time).format("hh:mm A")
        : null,
      status: dateData.order_status === "open" ? "active" : "inactive",
      note:""
    }
    axiosInstance
      .patch(
        `/customer/store/backout-dates/update/${storeId}?date=${dateData.date}`,
        payload
      )
      .then(() => {
        fetchBlackout();
        showSnackbar("Dates updated sucessfully");
      })
      .catch(() => {
        showSnackbar("Something went wrong!", "error");
      });
  };

  return (
    <div className="overflow-y-auto  hide-scrollbar h-[calc(100vh-210px)]">
      <div className="flex justify-center gap-6 flex-wrap md:flex-nowrap mb-4">
        {/* Calendar */}
        <div className="border border-gray-300 rounded-md p-4 bg-white shadow-lg">
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <StaticDatePicker
              displayStaticWrapperAs="desktop"
              value={selectedDate}
              onChange={(newValue) => {
                setSelectedDate(newValue);
                addToTemp(newValue);
              }}
            />
          </LocalizationProvider>
        </div>

        {/* Selected Dates Preview */}
        <div className="flex flex-col w-full max-w-[355px] border border-gray-300 rounded-md p-4 bg-white shadow-lg">
          <div className="text-lg font-semibold mb-2">Selected Dates</div>
          <ul className="space-y-2 flex-1 overflow-auto max-h-[300px] pb-3">
            {tempDates.length === 0 && (
              <li className="text-gray-500 text-sm">No dates selected</li>
            )}
            {tempDates.map((dateObj, index) => (
              <li
                key={index}
                className="flex justify-between items-center bg-blue-50 px-3 py-1 rounded text-sm"
              >
                {dateObj.date}
                <IconButton
                  size="small"
                  onClick={() => removeTempDate(dateObj.date)}
                  className="!text-red-600"
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </li>
            ))}
          </ul>

          <Button
            className={`mt-4 !rounded-lg !text-white !bg-[#3383B2] ${
              tempDates.length === 0 ? "opacity-60" : " hover:!bg-[#28709A]"
            }`}
            variant="contained"
            onClick={addAllToTable}
            disabled={tempDates.length === 0}
          >
            Add Blackout Dates
          </Button>
        </div>
      </div>
      <div className="mx-2 pb-4">
        {finalDates.length > 0 && (
          <BasicCustomTable
            columns={blackoutColumn}
            rows={finalDates}
            colorHeader={false}
            tableName="blackout"
            onTagChange={onStatusChange}
            handleTimeChange={handleTimeChange}
            handleAccept={onAccept}
          />
        )}
      </div>
    </div>
  );
}
